<template>
  <div class="clients">
    <div class="clients__body">
      <transition-group name="slide-fade">
          <div
              class="clients__item"
              v-for="(item, idx) in referrals"
              :key="idx"
              :class="{active: item.isActive}"
              @click="$emit('click', idx, item)"
          >
            <div class="clients__item-logo">
              <img :src="item.avatar" alt="" height="50px" width="50px" style="border-radius: 50%;border: 1px solid #DBBFA7;object-fit: cover;">
            </div>
            <div class="clients__item-top">
              <div class="clients__item-top-user">
                <div>
                  <div class="clients__item-fullname">{{ item.full_name.length > 1 ? item.full_name : 'Не указанно' }}</div>
                </div>
                <div>
                  <div class="clients__item-date">{{ $moment(item.created_at).format('DD.MM.YYYY LT') }}</div>
                </div>
              </div>
              <div class="clients__item-body">
                <p>{{ item.phone }}</p>
              </div>
            </div>
          </div>
        </transition-group>
        <div v-if="!referrals.length">
          <h4 style="text-align: center;margin-top: 20px;color: #38383885">Список пуст</h4>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefList',
  props: {
    referrals: Array,
  }
}
</script>
<style scoped lang="scss">
.clients {
  width: 100%;
  background-color: #fff;
  padding: 0 0;
}

.clients__item {
  padding: 10px 15px;
  border-bottom: 1px solid #E5E5E5;
  display: flex;

  &.active {
    color: #383838;
    background-color: rgba(219, 191, 167, 0.3);

    &:hover {
      opacity: 1;
    }
  }

  &-top {
    width: 100%;
    &-user {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &-fullname {
    font-weight: 600;
    font-size: 16px;
    color: #383838;
  }

  &-date {
    line-height: 24px;
    font-size: 14px;
    color: #808080;
  }

  &-logo {
    border: 1px solid #DBBFA7;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }

  &-body {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #808080;

    p {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

@media screen and (max-width: 1170px) {
  .clients__item-date {
    display: none;
  }
}
</style>
